// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"cookieBar_Wrapper__2HgO7","Text":"cookieBar_Text__1hrc7","Button":"cookieBar_Button__3-CN1"};